import { lazy } from 'react'

export const ChooseEvent = lazy(() => import('./ChooseEvent'))
